import {
    createPageMetricsForResponse,
    PageType,
} from '@jet-app/music-classical/metrics/page';
import { ObjectGraph } from '@jet/environment/dependencies';
import type {
    ClassicalAPIResponse,
    ClassicalGrid,
    ClassicalSection,
    ClassicalListViewPage,
} from '@jet-app/music-classical/api/types';
import type { LibraryAllPlaylistsPage } from '@jet-app/music-classical/models/pages/library/playlist';
import { transformToGridSection } from '@jet-app/music-classical/utilities/transforms/grid';

export function renderAllPlaylistsPage(
    canonicalURL: string,
    apiResponse: ClassicalAPIResponse,
    objectGraph: ObjectGraph,
): LibraryAllPlaylistsPage {
    const responseBody = apiResponse?.body as ClassicalListViewPage;
    const components =
        responseBody?.firstPage ||
        ((responseBody?.sections?.[0] as ClassicalSection)
            ?.components?.[0] as unknown as ClassicalGrid);
    const lockupKind = 'squareLockup';
    const sections =
        components?.type === 'empty'
            ? []
            : [
                  transformToGridSection(
                      components,
                      lockupKind,
                      undefined,
                      objectGraph,
                  ),
              ];

    return {
        pageKind: 'componentScreen',
        kind: 'LibraryAllPlaylistsPage',
        header: {} as any,
        sections,
        pageMetrics: createPageMetricsForResponse(
            apiResponse,
            PageType.libraryAllPlaylistsPage,
        ),
        canonicalURL,
    };
}
